import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Clock } from "lucide-react";

interface SessionTimeoutDialogProps {
  open: boolean;
  remainingSeconds: number;
  onExtendSession: () => void;
}

export function SessionTimeoutDialog({
  open,
  remainingSeconds,
  onExtendSession,
}: SessionTimeoutDialogProps) {
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
      return `${mins}:${secs.toString().padStart(2, "0")}`;
    }
    return `${secs} seconds`;
  };

  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-warning/10">
              <Clock className="h-6 w-6 text-warning" />
            </div>
            <div>
              <AlertDialogTitle>Session Timeout Warning</AlertDialogTitle>
              <AlertDialogDescription className="mt-1">
                Your session will expire due to inactivity.
              </AlertDialogDescription>
            </div>
          </div>
        </AlertDialogHeader>

        <div className="my-4 rounded-lg bg-muted p-4 text-center">
          <p className="text-sm text-muted-foreground mb-1">Time remaining</p>
          <p className="text-3xl font-bold text-foreground">{formatTime(remainingSeconds)}</p>
        </div>

        <p className="text-sm text-muted-foreground">
          For security, you will be automatically signed out when the timer expires. 
          Click the button below to continue your session.
        </p>

        <AlertDialogFooter className="mt-4">
          <AlertDialogAction onClick={onExtendSession} className="w-full">
            Continue Session
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
